import { render, staticRenderFns } from "./PreviewSection.vue?vue&type=template&id=c9822768&scoped=true&"
import script from "./PreviewSection.vue?vue&type=script&lang=js&"
export * from "./PreviewSection.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSection.vue?vue&type=style&index=0&id=c9822768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9822768",
  null
  
)

export default component.exports